import script from "./BottomToast.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomToast.vue?vue&type=script&setup=true&lang=js"

import "./BottomToast.vue?vue&type=style&index=0&id=adb54e00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adb54e00"]])

export default __exports__